import Constants from 'expo-constants';
import { Platform } from 'react-native';
import { makeRedirectUri } from 'expo-auth-session';

const appName = 'therapist';
const appVersion = Constants.expoConfig?.version as string;
const appType = 'therapist';
const address = process.env.EXPO_PUBLIC_API_URL;
const isProduction = process.env.EXPO_PUBLIC_ENVIRONMENT === 'production';
const environment: 'production' | 'development' | 'staging' = isProduction
  ? 'production'
  : process.env.EXPO_PUBLIC_ENVIRONMENT === 'staging'
    ? 'staging'
    : 'development';

const screenshotPreventionEnabled =
  process.env.EXPO_PUBLIC_SCREENSHOT_PREVENTION_ENABLED === 'true';
const bookingPageVisible = process.env.EXPO_PUBLIC_BOOKING_PAGE_VISIBLE;
const epaEnabled = process.env.EXPO_PUBLIC_EPA_ENABLED === 'true';
const unprotectedDeviceErrorEnabled =
  process.env.EXPO_PUBLIC_UNPROTECTED_DEVICE_ERROR_ENABLED === 'true';
const chargebeeSite = process.env.EXPO_PUBLIC_CHARGEBEE_SITE;
const legacyBackendCompatibility =
  process.env.EXPO_PUBLIC_LEGACY_BACKEND_COMPATIBILITY === 'true';
const sentryEnabled =
  process.env.EXPO_PUBLIC_ENVIRONMENT === 'production' ||
  process.env.EXPO_PUBLIC_ENVIRONMENT === 'staging';
const sentryDsn = process.env.EXPO_PUBLIC_SENTRY_DSN;
const healthCheckPath = legacyBackendCompatibility ? '' : 'api/health-check';
const therapistWebAppUrl = isProduction
  ? 'https://therapeut.neolexon.de'
  : 'https://therapeut-staging.neolexon.de';
const webAppUrl = isProduction
  ? 'https://app.neolexon.de'
  : 'https://app-staging.neolexon.de';

if (!address)
  throw new Error('Missing api url!, add EXPO_PUBLIC_API_URL="" to your .env');

// Data for the IDP REF-Environment
const idp = {
  clientIdApp: '886e0acd-3780-45e7-a5b3-2b8608d8f735',
  clientIdWeb: '4aa0eca4-f8a8-4246-a425-fb04630ce36a',
  redirectUrlApp: `${address}api/idp-auth-redirect`,
  redirectUrlWeb: makeRedirectUri({
    path: '/Home',
  }),
  authorizationEndpoint:
    'https://mimoto-ref.pie.azuma-health.tech/connect/auth',
  tokenEndpoint: 'https://mimoto-ref.pie.azuma-health.tech/connect/token',
  mimotoCodeExchangeEndpoint:
    'https://mimoto-ref.pie.azuma-health.tech/oidcf/exchange/mobile',
  scopes: ['urn:telematik:versicherter', 'openid'],
};

// TODO: Uncommented to only use the ref-environment until ePA can be released
// const isProduction = process.env.NODE_ENV === 'production';
// if (isProduction) {
//   idp.clientIdWeb = '3aa16531-24c0-4bba-9256-c29658da8467';
//   idp.clientIdApp = '48413243-5cda-435c-b40a-10922f020d13';
//   idp.authorizationEndpoint = 'https://mimoto.azuma-health.tech/connect/auth';
//   idp.tokenEndpoint = 'https://mimoto.azuma-health.tech/connect/token';
//   idp.mimotoCodeExchangeEndpoint =
//     'https://mimoto.azuma-health.tech/oidcf/exchange/mobile';
// }

export const constants = {
  address,
  environment,
  therapistWebAppUrl,
  webAppUrl,
  appName,
  appType,
  appVersion,
  epaEnabled,
  appMode: Constants.expoConfig?.extra?.mode,
  sentryEnabled,
  sentryDsn,
  isRunningInExpoGo: Constants.appOwnership === 'expo',
  chargebeeSite,
  bookingPageVisible,
  screenshotPreventionEnabled,
  unprotectedDeviceErrorEnabled,
  legacyBackendCompatibility,
  healthCheckPath,
  udiDi:
    Constants.expoConfig?.extra?.mode === 'therapist'
      ? '4260732410041'
      : '4260732410034',
  udiPi: () => {
    if (Platform.OS !== 'web') {
      return `${Constants.expoConfig?.extra?.mode === 'therapist' ? 'Therapeut' : 'Aphasie'}-${Platform.OS}-${appVersion}`.toUpperCase();
    } else {
      return `${Constants.expoConfig?.extra?.mode === 'therapist' ? 'Therapeut' : 'Aphasie'}-Browser-${appVersion}`.toUpperCase();
    }
  },
  idp,
};

export const WEBVIEW_ERROR_MESSAGE = {
  onError: 'Webview konnte nicht geladen werden',
  catchOnError:
    'Die Webansicht wurde nicht geladen. Wenden Sie sich an den Support',
  onMessage: 'Fehler im Webview-Skript',
  catchOnMessage:
    'Das Webview-Skript ist abgestürzt. Wenden Sie sich an den Support',
};

export const isPatientApp = constants.appMode === 'patient';
export default constants;
